module.exports = __webpack_public_path__ + "img/ag1.03e65772.png";